<template>
  <div>
    <!-- <button  >nihao</button> -->
    <!-- v-model="formValidate.province" -->
    <el-select style="margin-right: 70px; width: 280px" :class="selectBg" placeholder="国選択" @change="formData()" filterable v-model="formData" clearable>
      <el-option-group
        :class="groupBg"
        v-for="group in country"
        :key="group.label"
        :label="group.label"
      >
        <el-option
          :disabled="item.disabled"
          v-for="item in group.options"
          :key="item.value"
          :label="item.value"
          :value="item.value"
          type="button"
        ></el-option>
      </el-option-group>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "foreignArea",
  props: ['value'],
  data() {
    return {
      formData: "",
      country: [
        {
          label: "Popular country",
          options: [
            { value:"日本", label:"Japan" },
          ]
        },
        {
          label: "All country",
          options: [
            { value:"アブハジア", label:"Abkhazia, Republic of" },
            { value:"アフガニスタン", label:"Afghanistan" },
            { value:"アルバニア", label:"Albania" },
            { value:"アルジェリア", label:"Algeria" },
            { value:"アンドラ", label:"Andorra" },
            { value:"アンゴラ", label:"Angola" },
            { value:"アンティグア・バーブーダ", label:"Antigua and Barbuda" },
            { value:"アルゼンチン", label:"Argentina" },
            { value:"アルメニア", label:"Armenia" },
            { value:"オーストラリア", label:"Australia" },
            { value:"オーストリア", label:"Austria" },
            { value:"アゼルバイジャン", label:"Azerbaijan" },
            { value:"バハマ", label:"Bahamas" },
            { value:"バーレーン", label:"Bahrain" },
            { value:"バングラデシュ", label:"Bangladesh" },
            { value:"バルバドス", label:"Barbados" },
            { value:"ベラルーシ", label:"Belarus" },
            { value:"ベルギー", label:"Belgium" },
            { value:"ベリーズ", label:"Belize" },
            { value:"ベナン", label:"Benin" },
            { value:"ブータン", label:"Bhutan" },
            { value:"ボリビア", label:"Bolivia, Plurinational State of" },
            { value:"ボスニア・ヘルツェゴビナ", label:"Bosnia and Herzegovina" },
            { value:"ボツワナ", label:"Botswana" },
            { value:"ブラジル", label:"Brazil" },
            { value:"ブルネイ", label:"Brunei Darussalam" },
            { value:"ブルガリア", label:"Bulgaria" },
            { value:"ブルキナファソ", label:"Burkina Faso" },
            { value:"ブルンジ", label:"Burundi" },
            { value:"カンボジア", label:"Cambodia" },
            { value:"カメルーン", label:"Cameroon" },
            { value:"カナダ", label:"Canada" },
            { value:"カーボベルデ", label:"Cape Verde" },
            { value:"中央アフリカ共和国", label:"Central African Republic" },
            { value:"チャド", label:"Chad" },
            { value:"チリ", label:"Chile" },
            { value:"中国", label:"China" },
            { value:"コロンビア", label:"Colombia" },
            { value:"コモロ", label:"Comoros" },
            { value:"コンゴ共和国", label:"Congo" },
            { value:"コンゴ民主共和国", label:"Congo, the Democratic Republic of the" },
            { value:"クック諸島", label:"Cook Islands" },
            { value:"コスタリカ", label:"Costa Rica" },
            { value:"コートジボワール", label:"Côte d'Ivoire" },
            { value:"クロアチア", label:"Croatia" },
            { value:"キューバ", label:"Cuba" },
            { value:"キプロス", label:"Cyprus" },
            { value:"チェコ", label:"Czechia" },
            { value:"デンマーク", label:"Denmark" },
            { value:"ジブチ", label:"Djibouti" },
            { value:"ドミニカ国", label:"Dominica" },
            { value:"ドミニカ共和国", label:"Dominican Republic" },
            { value:"エクアドル", label:"Ecuador" },
            { value:"エジプト", label:"Egypt" },
            { value:"エルサルバドル", label:"El Salvador" },
            { value:"赤道ギニア", label:"Equatorial Guinea" },
            { value:"エリトリア", label:"Eritrea" },
            { value:"エストニア", label:"Estonia" },
            { value:"エチオピア", label:"Ethiopia" },
            { value:"フィジー", label:"Fiji" },
            { value:"フィンランド", label:"Finland" },
            { value:"フランス", label:"France" },
            { value:"ガボン", label:"Gabon" },
            { value:"ガンビア", label:"Gambia" },
            { value:"ジョージア", label:"Georgia" },
            { value:"ドイツ", label:"Germany" },
            { value:"ガーナ", label:"Ghana" },
            { value:"ギリシャ", label:"Greece" },
            { value:"グレナダ", label:"Grenada" },
            { value:"グアテマラ", label:"Guatemala" },
            { value:"ギニア", label:"Guinea" },
            { value:"ギニアビサウ", label:"Guinea-Bissau" },
            { value:"ガイアナ", label:"Guyana" },
            { value:"ハイチ", label:"Haiti" },
            { value:"バチカン", label:"Holy See (Vatican City State)" },
            { value:"ホンジュラス", label:"Honduras" },
            { value:"ハンガリー", label:"Hungary" },
            { value:"アイスランド", label:"Iceland" },
            { value:"インド", label:"India" },
            { value:"インドネシア", label:"Indonesia" },
            { value:"イラン", label:"Iran, Islamic Republic of" },
            { value:"イラク", label:"Iraq" },
            { value:"アイルランド", label:"Ireland" },
            { value:"イスラエル", label:"Israel" },
            { value:"イタリア", label:"Italy" },
            { value:"ジャマイカ", label:"Jamaica" },
            { value:"日本", label:"Japan" },
            { value:"ヨルダン", label:"Jordan" },
            { value:"カザフスタン", label:"Kazakhstan" },
            { value:"ケニア", label:"Kenya" },
            { value:"キリバス", label:"Kiribati" },
            { value:"北朝鮮", label:"Korea, Democratic People's Republic of" },
            { value:"韓国", label:"Korea, Republic of" },
            { value:"コソボ", label:"Kosovo" },
            { value:"クウェート", label:"Kuwait" },
            { value:"キルギス", label:"Kyrgyzstan" },
            { value:"ラオス", label:"Lao People's Democratic Republic" },
            { value:"ラトビア", label:"Latvia" },
            { value:"レバノン", label:"Lebanon" },
            { value:"レソト", label:"Lesotho" },
            { value:"リベリア", label:"Liberia" },
            { value:"リビア", label:"Libya" },
            { value:"リヒテンシュタイン", label:"Liechtenstein" },
            { value:"リトアニア", label:"Lithuania" },
            { value:"ルクセンブルク", label:"Luxembourg" },
            { value:"マケドニア旧ユーゴスラビア共和国", label:"Macedonia, the former Yugoslav Republic" },
            { value:"マダガスカル", label:"Madagascar" },
            { value:"マラウイ", label:"Malawi" },
            { value:"マレーシア", label:"Malaysia" },
            { value:"モルディブ", label:"Maldives" },
            { value:"マリ", label:"Mali" },
            { value:"マルタ", label:"Malta" },
            { value:"マーシャル諸島", label:"Marshall Islands" },
            { value:"モーリタニア", label:"Mauritania" },
            { value:"モーリシャス", label:"Mauritius" },
            { value:"メキシコ", label:"Mexico" },
            { value:"ミクロネシア連邦", label:"Micronesia, Federated States of" },
            { value:"モルドバ", label:"Moldova, Republic of" },
            { value:"モナコ", label:"Monaco" },
            { value:"モンゴル", label:"Mongolia" },
            { value:"モンテネグロ", label:"Montenegro" },
            { value:"モロッコ", label:"Morocco" },
            { value:"モザンビーク", label:"Mozambique" },
            { value:"ミャンマー", label:"Myanmar" },
            { value:"ナゴルノ・カラバフ", label:"Nagorno Karabagh Republic" },
            { value:"ナミビア", label:"Namibia" },
            { value:"ナウル", label:"Nauru" },
            { value:"ネパール", label:"Nepal" },
            { value:"オランダ", label:"Netherlands" },
            { value:"ニュージーランド", label:"New Zealand" },
            { value:"ニカラグア", label:"Nicaragua" },
            { value:"ニジェール", label:"Niger" },
            { value:"ナイジェリア", label:"Nigeria" },
            { value:"ニウエ", label:"Niue" },
            { value:"北キプロス", label:"Northern Cyprus" },
            { value:"ノルウェー", label:"Norway" },
            { value:"オマーン", label:"Oman" },
            { value:"パキスタン", label:"Pakistan" },
            { value:"パラオ", label:"Palau" },
            { value:"パレスチナ", label:"Palestinian Territory, Occupied" },
            { value:"パナマ", label:"Panama" },
            { value:"パプアニューギニア", label:"Papua New Guinea" },
            { value:"パラグアイ", label:"Paraguay" },
            { value:"ペルー", label:"Peru" },
            { value:"フィリピン", label:"Philippines" },
            { value:"ポーランド", label:"Poland" },
            { value:"ポルトガル", label:"Portugal" },
            { value:"沿ドニエストル", label:"Pridnestrovian Moldavian Republic" },
            { value:"カタール", label:"Qatar" },
            { value:"ルーマニア", label:"Romania" },
            { value:"ロシア", label:"Russian Federation" },
            { value:"ルワンダ", label:"Rwanda" },
            { value:"セントクリストファー・ネイビス", label:"Saint Kitts and Nevis" },
            { value:"セントルシア", label:"Saint Lucia" },
            { value:"セントビンセントおよびグレナディーン諸島", label:"Saint Vincent and the Grenadines" },
            { value:"サモア", label:"Samoa" },
            { value:"サンマリノ", label:"San Marino" },
            { value:"サントメ・プリンシペ", label:"Sao Tome and Principe" },
            { value:"サウジアラビア", label:"Saudi Arabia" },
            { value:"セネガル", label:"Senegal" },
            { value:"セルビア", label:"Serbia" },
            { value:"セーシェル", label:"Seychelles" },
            { value:"シエラレオネ", label:"Sierra Leone" },
            { value:"シンガポール", label:"Singapore" },
            { value:"スロバキア", label:"Slovakia" },
            { value:"スロベニア", label:"Slovenia" },
            { value:"ソロモン諸島", label:"Solomon Islands" },
            { value:"ソマリア", label:"Somalia" },
            { value:"ソマリランド", label:"Somaliland, Republic of" },
            { value:"南アフリカ", label:"South Africa" },
            { value:"南オセチア", label:"South Ossetia" },
            { value:"南スーダン", label:"South Sudan" },
            { value:"スペイン", label:"Spain" },
            { value:"スリランカ", label:"Sri Lanka" },
            { value:"スーダン", label:"Sudan" },
            { value:"スリナム", label:"Suriname" },
            { value:"スワジランド", label:"Swaziland" },
            { value:"スウェーデン", label:"Sweden" },
            { value:"スイス", label:"Switzerland" },
            { value:"シリア", label:"Syrian Arab Republic" },
            { value:"台湾", label:"Taiwan, Province of China" },
            { value:"タジキスタン", label:"Tajikistan" },
            { value:"タンザニア", label:"Tanzania, United Republic of" },
            { value:"タイ", label:"Thailand" },
            { value:"東ティモール", label:"Timor-Leste" },
            { value:"トーゴ", label:"Togo" },
            { value:"トンガ", label:"Tonga" },
            { value:"トリニダード・トバゴ", label:"Trinidad and Tobago" },
            { value:"チュニジア", label:"Tunisia" },
            { value:"トルコ", label:"Turkey" },
            { value:"トルクメニスタン", label:"Turkmenistan" },
            { value:"ツバル", label:"Tuvalu" },
            { value:"ウガンダ", label:"Uganda" },
            { value:"ウクライナ", label:"Ukraine" },
            { value:"アラブ首長国連邦", label:"United Arab Emirates" },
            { value:"イギリス", label:"United Kingdom" },
            { value:"アメリカ", label:"United States" },
            { value:"ウルグアイ", label:"Uruguay" },
            { value:"ウズベキスタン", label:"Uzbekistan" },
            { value:"バヌアツ", label:"Vanuatu" },
            { value:"ベネズエラ", label:"Venezuela, Bolivarian Republic of" },
            { value:"ベトナム", label:"Viet Nam" },
            { value:"西サハラ", label:"Western Sahara" },
            { value:"イエメン", label:"Yemen" },
            { value:"ザンビア", label:"Zambia" },
            { value:"ジンバブエ", label:"Zimbabwe" }, 
          ]
        }
      ]
    };
  },
  watch: {
    formData() {
      this.$emit('selectCountry', this.formData);
      return this.value
    }
  }
};
</script>

<style>
.groupBlue {
  background-color: #00355d;
  width: 170px;
}
.selectBlue .el-input .el-input__inner {
  background-color: #00355d;
  border: none;
  width: 170px;
}
.groupBlack {
  width: 170px;
}
.selectBlack .el-input .el-input__inner {
  border: none;
  width: 170px;
}
.groupWhite {
  background-color: #d9d9d9;
  width: 170px;
}
.selectWhite .el-input .el-input__inner {
  border: none;
  background-color: #d9d9d9;
  width: 170px;
}
</style>


// WEBPACK FOOTER //
// src/components/Public/ForeignArea.vue